import React, { Component } from 'react';
import { connect } from 'react-redux';
import OwlCarousel from 'react-owl-carousel2';
import axios from 'axios';
import Loader from 'react-loader-spinner';
import Layout from '../layout/Layout';
import Callusnow from './Callusnow';
import queryString from 'query-string';
import Reaptcha from 'reaptcha';
import $ from 'jquery';  
var fs = require('browserify-fs');
const API_URL = process.env.REACT_APP_API_URL;
const PAYMENT_URL = process.env.REACT_APP_PAYMENT_URL;
const IMAGE_URL = process.env.REACT_APP_SITE_IMAGE_URL;

class Donate extends Component {
	
	constructor(props) {
        super(props);

  let full_name = queryString.parse(this.props.location.search).full_name ? queryString.parse(this.props.location.search).full_name : '';
  let email = queryString.parse(this.props.location.search).email ? queryString.parse(this.props.location.search).email : '';
  let phone = queryString.parse(this.props.location.search).phone ? queryString.parse(this.props.location.search).phone : '';
  let amount = queryString.parse(this.props.location.search).amount ? queryString.parse(this.props.location.search).amount : '';

        this.state = {
          
            slider: [],
			loaded: false,
			home:[],
			Ourreach:[],
			statelist:[],
			Volunteeringworks:[],
			Workingtogether:[],
			Aboutourfoundation:[],
			OurImpact:[], 
			fields: {
				name:full_name ? full_name : '',
				email:email ? email : '',
				phone:phone ? phone : '',
				amount:amount ? amount : '',
				pannumber:''
			},
			errors: {},
			languagedata:[],
			defaultlang:6,
			verified: false
			
			
        };
		
		
	    this.handleChange = this.handleChange.bind(this);
		this.submitdonateform = this.submitdonateform.bind(this);

		 
		
    }
	
	  onVerify = recaptchaResponse => {
    this.setState({
      verified: true
    });
  };


	handleChange(e) {
      let fields = this.state.fields;
      fields[e.target.name] = e.target.value;
      this.setState({
        fields
      });

    }
	
	componentDidMount() {


		$('html, body').animate({
		scrollTop:0
		}, 1000);

	  	const DefaultLang = localStorage.getItem('DefaultLanguage');
	    this.setState({defaultlang: DefaultLang});
	
    
  }


  	componentWillMount() {
    	
	  	const DefaultLang = localStorage.getItem('DefaultLanguage');
	   this.getStatedata(DefaultLang);
	this.getlanguage(DefaultLang);
    
  }
getStatedata(defaultlang){
    
   
    axios.post(`${API_URL}/getstate`, { LanguageId:defaultlang})
        
        .then(res => {
       
          if(res.data.Status == 1)
          {
            const statelist = res.data.ResponseData;
             this.setState({ statelist }); 
          }else{
          	this.setState({ statelist:[] }); 
          }
          })
        
        
        
}

getlanguage(defaultlang){
    
   
    axios.post(`${API_URL}/langfile`, { LangId:defaultlang})
        
        .then(res => {
       
          if(res.data.Status == 1)
          {
            const language = res.data.ResponseData;
            let data = res.data.ResponseData[0];
           
             const mythis=this;
             this.setState({ language }); 

              this.setState({languagedata: data});
             
           
                     
            
          }
          })
        
        
        
}
	validateForm() {

      let fields = this.state.fields;
      let errors = {};
      let formIsValid = true;

      if (!fields["name"]) {
        formIsValid = false;
        errors["name"] = "Please enter full name.";
      }

      if (typeof fields["name"] !== "undefined") {
        if (!fields["name"].match(/^[a-zA-Z ]*$/)) {
          formIsValid = false;
          errors["name"] = "Please enter alphabet characters only.";
        }
      }
	  
	  
	  if (!fields["email"]) {
        formIsValid = false;
        errors["email"] = "Please enter email-ID.";
      }

      if (typeof fields["email"] !== "undefined") {
        //regular expression for email validation
        var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
        if (!pattern.test(fields["email"])) {
          formIsValid = false;
          errors["email"] = "Please enter valid email-ID.";
        }
      }
	  
	  
	   if (!fields["phone"]) {
        formIsValid = false;
        errors["phone"] = "Please enter phone no.";
      }

      if (typeof fields["phone"] !== "undefined") {
        if (!fields["phone"].match(/^[0-9]{10}$/)) {
          formIsValid = false;
          errors["phone"] = "Please enter valid phone no.";
        }
      }
	  
	  
	  if (!fields["pannumber"]) {
        formIsValid = false;
        errors["pannumber"] = "Please enter PAN number.";
      }
	  if (typeof fields["pannumber"] !== "undefined") {
        if (!fields["pannumber"].match(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/)) {
          formIsValid = false;
          errors["pannumber"] = "Please Valid PAN Number.";
        }
      }
	  
	  
	   if (!fields["amount"]) {
        formIsValid = false;
        errors["amount"] = "Please enter helping amount.";
      }

      if (typeof fields["amount"] !== "undefined") {
        if (!fields["amount"].match(/^\-?([0-9]+(\.[0-9]+)?|Infinity)$/)) {
          formIsValid = false;
          errors["amount"] = "Please enter numbers only.";
        }
      }
	  
	  if(this.state.verified==false){
	  	 formIsValid = false;
        errors["captcha"] = "Please Select Reaptcha.";
		}
	  
	  

      this.setState({
        errors: errors
      });
      return formIsValid;


    }
	
	
submitdonateform(e) {
	
      e.preventDefault();
      if (this.validateForm()) {
          
         this.setState({ loaded: true });
		 axios.post(`${API_URL}/donate`, {
		 LanguageID:6,		
		 amount:this.state.fields.amount,
		 name: this.state.fields.name,
		 email:this.state.fields.email,
		 pannumber:this.state.fields.pannumber,
		 phone:this.state.fields.phone,
		 address1:this.state.fields.address1,
		 address2:this.state.fields.address2,
		 city:this.state.fields.city,
		 province:this.state.fields.province,
		 postcode:this.state.fields.postcode,
		 country:this.state.fields.country,
		 })
		  .then(res => {
		this.setState({ loaded: false });
        this.setState({ errorMessage: res.data.Message,status_code:res.data.Status});
		
        
		
		if(res.data.Status!='0'){
        
		
				
               window.location.href=PAYMENT_URL+'payamentpage?amount='+this.state.fields.amount+'&name='+this.state.fields.name+'&email='+this.state.fields.email+'&phone='+this.state.fields.phone+'&d_id='+res.data.Donateid;
            
			
		
		
      }
	 
		  })
		  
      }else{
      	$('html, body').animate({
		scrollTop:$("#Address_title_scroll").offset().top-50
		}, 1000);
      }

 }
	

	
	
	
	
  render() {

	  
    return (
      	<div className="App">
      		<Layout languagedata={this.state.languagedata}>
	
	{this.state.loaded == true ? (	  		
			<div className="divloader"> 
		 <Loader 
			 type="TailSpin"
			 color="#00BFFF"
			 height="100"	
			 width="100"
		  />		  
	 </div>
	
	) : '' }
			
			
			
      			<section className="banner inner_banner">
				  <div className="bd-example">
				    <div id="carouselExampleCaptions" className="carousel slide" data-ride="carousel">
				      <div className="carousel-inner">
				        <div className="carousel-item active">
				          <img src={ IMAGE_URL+'/images/donate-banner.jpg' } className="d-block w-100" alt={"Swacch Bharat - "+this.state.languagedata.donate_now} />
				          <div className="carousel-caption d-none d-md-block">
				            <h1>{this.state.languagedata.donate_now}</h1>
				          </div>
				        </div>
				      </div>
				    </div>
				  </div>
				</section>

				<section className="contact_us Donate_form">
				
			<form className="form-horizontal has-validation-callback" onSubmit= {this.submitdonateform}>
				<div className="container">
				  <div className="row">
				    <div className="col-12">
				      <h2 className="Address_title" id="Address_title_scroll">{this.state.languagedata.Select_The_Amount_You_Wish_To_Donate}</h2>
				    </div>
				   
				    <div className="col-xl-6 col-lg-6 col-md-6">
				      <div className="form-group">
				        <label for="amount">
				        {this.state.languagedata.Helping_Amount}*</label>
				        <input type="text"
				         name="amount"
				         id="amount"
				         autoComplete="off"
				         className={this.state.errors.amount ? "form-control error_class" : "form-control"}
				         placeholder={this.state.errors.amount ? this.state.errors.amount : ""}
				         onChange={this.handleChange}
				         defaultValue={this.state.fields.amount} 
				         onKeyPress={this.isNumber} pattern="[0-9]*"/>
						
				      </div>
					
					  
					 </div>
					 
					<div className="col-xl-6 col-lg-6 col-md-6">
					 <div className="form-group">
				        <label for="name">
				          {this.state.languagedata.Name}*</label>
				        <input type="text"
				         name="name"
				         id="name"
				         autoComplete="off"
				         className={this.state.errors.name ? "form-control error_class" : "form-control"}
				         placeholder={this.state.errors.name ? this.state.errors.name : ""}
				         onChange={this.handleChange}
				         defaultValue={this.state.fields.name}
				         />
				       
					  </div>
					  
					  
					  
				    </div>
				  </div>

				  <div className="row">
				    <div className="col-xl-3 col-lg-3 col-md-3">
				      
				      <div className="form-group">
				        <label for="email">
				          {this.state.languagedata.Email_Address}*</label>
				        <div className="input-group">          
				          <input type="email"
				           name="email"
				           id="email"
				           autoComplete="off"
				            className={this.state.errors.email ? "form-control error_class" : "form-control"}
				         placeholder={this.state.errors.email ? this.state.errors.email : ""}
				              onChange={this.handleChange}
				               defaultValue={this.state.fields.email}
				               />
						   
				        </div>
						
				      </div>      
				    </div>
					<div className="col-xl-3 col-lg-3 col-md-3">  
				      <div className="form-group">
				        <label for="phone">
				          {this.state.languagedata.Phone}*</label>
				        <div className="input-group">
				          <input type="text"
				           name="phone"
				           id="phone"
				           autoComplete="off"
				            className={this.state.errors.phone ? "form-control error_class" : "form-control"}
				         placeholder={this.state.errors.phone ? this.state.errors.phone : ""}
				              onChange={this.handleChange}
				               defaultValue={this.state.fields.phone}
				               />
						   
				        </div>
						
				      </div>
					  
				    </div>
				    <div className="col-xl-6 col-lg-6 col-md-6">
				      <div className="form-group">
				        <label for="pannumber">
				          {this.state.languagedata.PAN_number}*</label>
				        <input type="text"
				         name="pannumber"
				         id="pannumber"
				         autoComplete="off"
				          className={this.state.errors.pannumber ? "form-control error_class" : "form-control"}
				         placeholder={this.state.errors.pannumber ? this.state.errors.pannumber : ""}
				            onChange={this.handleChange}
				            />
						
					  </div>
					  
					  
					</div>

					
					 
				</div>
				<div className="row">
				  <div className="col-12">
				    <h2 className="Address_title">{this.state.languagedata.Address}</h2>
				  </div>
				  <div className="col-12 col-xl-6 col-lg-6 col-md-6">
				    <div className="form-group">
				      <label for="address1">
				        {this.state.languagedata.Street_Address}</label>
				      <input type="text" name="address1" id="address1" className="form-control" autoComplete="off" placeholder="" onChange={this.handleChange} />
				    </div>
				  </div>
				  <div className="col-12 col-xl-6 col-lg-6 col-md-6">
				    <div className="form-group">
				      <label for="address2">
				      {this.state.languagedata.Address_Line_2}</label>
				      <input type="text" autoComplete="off" name="address2" id="address2" className="form-control" placeholder="" onChange={this.handleChange} />
				    </div>
				  </div>
				  <div className="col-xl-3 col-lg-3 col-md-3">
				    <div className="form-group">
				      <label for="province">
				      {this.state.languagedata.State_Province_Region}</label>
				      
				      <select name="province" id="province" className="form-control" 
				      onChange={this.handleChange} >
							<option value="">Select State</option>
							{this.state.statelist.map((item) => 
								<option value={item.StateName}>{item.StateName}</option>
							)} 
							</select>
				    </div>
				  </div>
				  <div className="col-xl-3 col-lg-3 col-md-3">
				    <div className="form-group">
				      <label for="city">
				        {this.state.languagedata.City}</label>
				      <input type="text" autoComplete="off" id="city" name="city" className="form-control" placeholder="" onChange={this.handleChange} pattern="^[a-zA-Z]+(?:(?:\\s+|-)[a-zA-Z]+)*$" title="Enter Valid City Name" />
				    </div>
				  </div>
				  
				  <div className="col-xl-3 col-lg-3 col-md-3">
				    <div className="form-group">
				      <label for="postcode">
				        {this.state.languagedata.ZIP_Postal_Code}</label>
				      <input type="text" autoComplete="off" id="postcode" name="postcode" className="form-control" placeholder="" onChange={this.handleChange} pattern="[0-9]*"  title="Enter Valid Zip Code"/>
				    </div>
				  </div>
				  <div className="col-xl-3 col-lg-3 col-md-3">
				    <div className="form-group">
				      <label for="country">
				      {this.state.languagedata.Country}</label>
				     <select name="country" id="country" onChange={this.handleChange} >
				       <option>india</option>
				     </select>
				    </div>
				  </div>
				</div>


<div className="row">
	<div className="col-12 text-left">
		<Reaptcha sitekey="6LdP6-EUAAAAAOUXIJ7-MRV73C_LwXO98dy8cMJX" onVerify={this.onVerify} />
		<div className="text-danger">{this.state.errors.captcha}</div>
    </div>
</div>

				<div className="row">
				  <div className="col-12">
				  <button type="submit" className="btn btn-primary" id="btnContactUs">
				    {this.state.languagedata.Proceed_to_Payment}</button>
					
				  </div>
				</div>



				 
				</div>
				</form>
				</section>

				<Callusnow languagedata={this.state.languagedata} />

			</Layout>
	  	</div>
    );
  }
}

export default Donate;



// WEBPACK FOOTER //
// ./src/component/Donate.js